function CustomTooltip(selector) {
  const itens = $(selector);
  const options = {
    template: `<div class="tooltip tooltip-icon-cell" role="tooltip">
        <div class="tooltip-arrow"></div>
        <div class="tooltip-inner"></div>
      </div>`,
    container: 'body',
  };

  itens.tooltip(options);
}

export default CustomTooltip;
